export default __webpack_public_path__ + "static/media/aim.e2db594e.svg";